const projects = [
  {
    label: "Lotto",
    info: "An End to end progressive application for Lotto service served with a full functional backend including authentication and Database manipulation",
    link: "https://play.google.com/store/apps/details?id=com.liors.lottery.first.project",
    img: "/projects-images/lotto.png",
    using: ["React Native", "Typescript", "NodeJs", "ExpressJs", "MongoDb", "Firebase"],
  },
  {
    label: "Bank",
    info: "An End to end progressive web application for bank service served with a full functional backend including authentication and Database manipulation",
    link: "https://lioraharon98.github.io/bank/",
    img: "/projects-images/bank.webp",
    using: ["React", "Html5", "Css3", "NodeJs", "ExpressJs", "MongoDb", "Firebase"],
  },
  {
    label: "Super market",
    info: "An End to end progressive web application for online shopping served with a full functional backend including authentication and Database manipulation",
    link: "https://lioraharon98.github.io/supermarket/",
    img: "/projects-images/supermarket.jpg",
    using: ["React", "Javascript", "Html5", "Css3", "NodeJs", "ExpressJs", "MongoDb", "Firebase", "Ejs"],
  },
  {
    label: "Decibel meter",
    info: "an decibel meter display decibel and frequency with anomaly detection after data send to database ",
    link: "https://next-js-decibel-meter.herokuapp.com/",
    img: "/projects-images/decibel-meter.webp",
    using: ["NextJs", "Html5", "Css3", "NodeJs", "ExpressJs", "MongoDb"],
  },
];
export default projects;
